/** Client-side pagination helpers for Port Performance tables (full dataset from API). */

export function slicePage<T>(
  data: T[] | null | undefined,
  pageIndex: number,
  pageSize: number,
): T[] {
  const source = data ?? [];
  if (!source.length || pageSize <= 0) {
    return [];
  }
  const safePageIndex = clampPageIndex(pageIndex, source.length, pageSize);
  const start = safePageIndex * pageSize;
  return source.slice(start, start + pageSize);
}

export function clampPageIndex(
  pageIndex: number,
  totalItems: number,
  pageSize: number,
): number {
  if (totalItems <= 0 || pageSize <= 0) {
    return 0;
  }
  const maxPage = Math.max(0, Math.ceil(totalItems / pageSize) - 1);
  return Math.min(Math.max(0, pageIndex), maxPage);
}

export function getPaginatedRowSerialNumber(
  pageIndex: number,
  pageSize: number,
  rowIndex: number,
): number {
  return pageIndex * pageSize + rowIndex + 1;
}
